module.exports = __webpack_public_path__ + "static/media/014-Aufraeumen_mV_ID_7.8020bc31.mp3";